import {LocalPackFilterType} from '../../../page/main/local-pack/local-pack-filter/local-pack-filter-type';
import {getLocalPackFilterValues} from '../../../page/main/local-pack/local-pack-helper';
import {fetchAndDeserialize} from '../../../util/api-adapter';
import {PaginationDataType} from '../../../util/pagination-hook/pagination-hook-type';
import {TableSorterType} from '../../../util/table';
import {objectToUrlParameters} from '../../../util/url';

import {
    localPackSearchPhrasesAnalyticsResponseSchema,
    LocalPackSearchPhrasesStatisticsType,
} from './local-pack-search-phrases-statistics-type';

export function fetchLocalPackSearchPhrasesStatistics(
    options: PaginationDataType & {
        filter: LocalPackFilterType;
        mainFilterKey: string;
    } & TableSorterType
): Promise<LocalPackSearchPhrasesStatisticsType> {
    const {page, pageSize, mainFilterKey, sorterField, sorterDirection, filter} = options;

    const url = `/cp/local_pack/locations_and_queries/?${objectToUrlParameters({
        page,
        page_size: pageSize,
        filter_key: mainFilterKey,
        ...(sorterField && sorterDirection
            ? {
                  sort_field: String(sorterField),
                  sort_direction: sorterDirection,
              }
            : {}),
        ...getLocalPackFilterValues(filter),
    })}`;

    return fetchAndDeserialize(url, localPackSearchPhrasesAnalyticsResponseSchema, {
        fetchOptions: {
            skipCache: true,
        },
    });
}
